/* eslint-disable import/prefer-default-export */

/**
 * Given the state fields for a single state, from a GraphQL query such as:
 *
 *    query StateRegistrationInformation($id: String) {
 *      voteAmericaState(code: { eq: $id }) {
 *        name
 *        code
 *        state_information {
 *          html
 *          text
 *          value
 *          modified_at
 *          field {
 *            slug
 *          }
 *        }
 *      }
 *    }
 *
 * Returns the state's fields indexed by slug, i.e.:
 *
 *   {
 *     some_slug_here: {
 *       text: "True",
 *       value: true,
 *       html: "<p>true</p>"
 *     }
 *   }
 */
export function indexStateDataBySlug(state) {
  const data = {};

  state.state_information.forEach((obj) => {
    if (obj?.field?.slug) {
      // eslint-disable-next-line no-param-reassign
      data[obj.field.slug] = {
        text: obj.text,
        html: obj.html,
        bool_value: obj.bool_value,
        multiselect_value: obj.multiselect_value,
        footnotes: obj.footnotes,
      };
    }
  });

  return data;
}
